import React from 'react';
import { useDocumentContext } from '../../../contexts/DocumentContext';
import SkeletonLoader from './SkeletonLoader';
import CircularProgressRing from 'components/common/CircularProgressRing';
import HeaderStats from './HeaderStats';
import styles from '../../../styles/DocumentManagement.module.css';

const OverviewHeader: React.FC = ({ }) => {
    const { overallStats, structuralLoading } = useDocumentContext();
    return (
        <>
            {structuralLoading ? (
                <SkeletonLoader variant="overviewHero" count={4} />
            ) : (
                <div className={styles.overviewHero} >
                    <CircularProgressRing overallStats={overallStats} />
                    <HeaderStats overallStats={overallStats} />
                </div >
            )}
        </>
    );
}

export default OverviewHeader;